<template>
  <q-card flat class="q-pa-sm no-padding-md" style="max-width: 100vw">
    <q-card-section class="row q-pb-xs text-green-vito justify-between">
      <div class="text-h5">
        {{ $t("title.logs_detail") }}
      </div>
    </q-card-section>

    <q-card-section>
      <q-table
        :rows="report"
        :columns="columnsI18n"
        row-key="id"
        :loading="loading"
        :filter="filter"
        :rows-per-page-options="[0]"
        binary-state-sort
        class="sticky-header-table"
      >
        <template v-slot:body-cell-bottle="props">
          <q-td :style="`background:${props.row.style};`" :props="props">
            {{ props.value }}
          </q-td>
        </template>
        <template v-slot:body-cell-cause="props">
          <q-td :style="`background:${props.row.causeStyle};`" :props="props">
            {{ props.value }}
          </q-td>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
</template>
<script>
import moment from "moment";
import ReportApi from "../../apis/Report";
import { useI18n } from "vue-i18n";

export default {
  props: ["startDate", "store"],

  setup() {
    const { locale } = useI18n({ useScope: "global" });
    return {
      locale,
    };
  },
  data: () => {
    return {
      action: "list",
      showNew: false,
      showCard: false,
      filter: "",
      loading: false,
      report: [],
    };
  },
  methods: {
    async getReportDetail() {
      this.loading = true;
      try {
        const day_plus_one = moment(this.startDate).add(1, "d");
        const reportReponse = await ReportApi.getLogsDetailReport(
          moment(this.startDate).format("yyyy-MM-DD"),
          day_plus_one.format("yyyy-MM-DD"),
          this.store
        );

        this.report = reportReponse.data.sort((a, b) =>
          moment(a.created_at).isBefore(moment(b.created_at)) ? -1 : 1
        );
        this.report.forEach((r) => {
          if (
            !r.bottle &&
            r.status == 1 && 
            moment(r.created_at) < moment(this.startDate) &&
            moment(r.lastseen_at) > day_plus_one
          ) {
            // bouteille vide
            r.style = "orange";
          } else if (
            !r.bottle &&
            r.status == 1 && 
            r.cause == "Theft ?" &&
            moment(r.created_at).startOf('day').format('YYYY-MM-DD') == moment(this.startDate).format('YYYY-MM-DD')
          ) {
            // vol
            r.style = "red";
          } else {
            r.style = "white";
          }

          if (
            r.cause == "Bottle Sensor ?" &&
            Math.abs(
              moment(r.created_at).diff(moment(this.startDate), "days")
            ) < 2
          ) {
            r.causeStyle = "red";
          } else {
            r.causeStyle = "white";
          }
        });

        this.loading = false;
        //
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },
    async viewDetail() {},
    async refresh() {
      this.showNew = false;
      this.showCard = false;
      await this.getReport();
    },

    getStatusName(state) {
      switch (state) {
        case 0:
          return "BOOT";
        case 1:
          return "READY";
        case 2:
          return "OPEN";
        case 3:
          return "TRANSACTION_OK";
        case 4:
          return "REFILL_PENDING";
        case 5:
          return "NOT_SEEN";
        default:
          return "TODO";
      }
    },

    getReasonTranslation(reason) {
      switch (reason) {
        case "Refill":
          return "Rechargement";
        case "Ignore door closed":
          return "Fermeture porte";
        case "Order":
          return "Commande";
        case "Bottle Sensor ?":
          return "Pb capteur bouteille";
        case "Theft ?":
          return "Suspicion vol";
        default:
          return reason;
      }
    },
  },

  async mounted() {
    await this.getReportDetail();
  },

  computed: {
    columnsI18n() {
      const columns = [
        {
          name: "id",
          required: true,
          label: this.$t("label.id"),
          align: "left",
          field: "id",
          sortable: true,
        },
        {
          name: "date",
          required: true,
          label: this.$t("label.date"),
          align: "left",
          field: "created_at",
          sortable: true,
        },
        {
          name: "lastseen",
          required: true,
          label: this.$t("label.lastseen"),
          align: "left",
          field: "lastseen_at",
          sortable: true,
        },
        {
          name: "locker",
          required: true,
          label: this.$t("label.locker"),
          align: "left",
          field: (row) => row.locker.numero,
          sortable: true,
          sort: (a, b, rowA, rowB) => {
            if(rowA.locker.numero[0] != rowB.locker.numero[0]) return rowA.locker.numero[0].localeCompare(rowB.locker.numero[0]);
            return parseInt(rowA.locker.numero.substring(1)) - parseInt(rowB.locker.numero.substring(1))

          }
        },
        {
          name: "locker_id",
          required: true,
          label: this.$t("label.id"),
          align: "left",
          field: (row) => row.locker.id,
          sortable: true,
        },
        {
          name: "bottle_before",
          required: true,
          label: this.$t("label.bottle_before"),
          align: "left",
          field: (row) =>
            row.oldState
              ? row.oldState.bottle
                ? "Present"
                : "Absent"
              : "Inconnu",
          sortable: true,
        },
        {
          name: "bottle",
          required: true,
          label: this.$t("label.bottle"),
          align: "left",
          field: (row) => (row.bottle ? "Present" : "Absent"),
          sortable: true,
        },
        {
          name: "door_before",
          required: true,
          label: this.$t("label.door_before"),
          align: "left",
          field: (row) =>
            row.oldState ? (row.oldState.door ? "Closed" : "Open") : "Inconnu",
          sortable: true,
        },
        {
          name: "door",
          required: true,
          label: this.$t("label.door"),
          align: "left",
          field: (row) => (row.door ? "Closed" : "Open"),
          sortable: true,
        },
        {
          name: "status_before",
          required: true,
          label: this.$t("label.status_before"),
          align: "left",
          field: (row) =>
            row.oldState ? this.getStatusName(row.oldState.status) : "Inconnu",
          sortable: true,
        },
        {
          name: "status",
          required: true,
          label: this.$t("label.status"),
          align: "left",
          field: (row) => this.getStatusName(row.status),
          sortable: true,
        },
        {
          name: "cause",
          required: true,
          label: this.$t("label.cause"),
          align: "left",
          field: (row) => this.getReasonTranslation(row.cause),
          sortable: true,
        },
      ];
      return columns;
    },
  },
};
</script>
